import React, { useState } from 'react';
import { Box, Label, Toggle } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import { assetType, selectSelectedAssetType, toggleSelectedAssetType } from '../../core/reducers/ui';
import gtmTrimToggleClick from '../../core/gtm/gtmTrimToggleClick';
import themeStyles from './TrimOverview.styles';
import { useAppSelector, useAppDispatch } from '../../core/utils';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
const StyledWrapper = themeStyles.apply(Box, 'StyledWrapper');
const StyledLabel = themeStyles.apply(Label, 'StyledLabel');
const TrimToggle = ({ gtmVehicleData, isExterior, isInventoryVariant }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { inventoryStatus } = useAppSelector(selectCurrentVehicle);
    const selectedType = useAppSelector(selectSelectedAssetType);
    const isToggleOn = selectedType === assetType.interior;
    const [isChecked, setIsChecked] = useState(isToggleOn);
    const toggleChangeHandler = (type) => {
        if (type !== undefined && selectedType !== type) {
            dispatch(toggleSelectedAssetType());
            setIsChecked(!isChecked);
            gtmTrimToggleClick({
                ...gtmVehicleData,
                availabilityFlag: inventoryStatus,
                isInventoryVariant,
                galleryType: isToggleOn ? assetType.exterior : assetType.interior,
            });
        }
    };
    return (React.createElement(StyledWrapper, { isExterior: isExterior, "data-testid": "cy-trim-toggle" },
        React.createElement(StyledLabel, { onClick: () => toggleChangeHandler(assetType.exterior) }, t('Pages.Models.Exploration.exteriorLabel')),
        React.createElement(Toggle, { ariaLabel: t('Shared.Common.toggleExteriorAndInteriorAria'), ariaLabelledby: isToggleOn ? assetType.exterior : assetType.interior, key: isToggleOn, checked: isToggleOn, id: isToggleOn ? assetType.exterior : assetType.interior, onClick: toggleChangeHandler }),
        React.createElement(StyledLabel, { onClick: () => toggleChangeHandler(assetType.interior) }, t('Pages.Models.Exploration.interiorLabel'))));
};
export default TrimToggle;
